"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponsWrap = exports.CouponAccordion = exports.DataWrap = exports.CenteredStack = exports.OrderPriceWrap = exports.OrderTax = exports.OrderPrice = exports.OrderPriceTitle = exports.SmallSkeleton = exports.PriceRowValue = exports.PriceRowTitle = exports.ProductTax = exports.ProductPrice = exports.ProductTitle = exports.ProductWrap = exports.Divider = exports.MotionOrderCard = exports.OrderCard = exports.InfoWrap = exports.Title = exports.Wrap = exports.CouponGrid = void 0;
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const framer_motion_1 = require("framer-motion");
exports.CouponGrid = (0, app_1.styled)(ui_1.Grid) `
  margin-top: 1rem;
  @media ${app_1.notDesktop} {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
  }
`;
exports.Wrap = (0, app_1.styled)(ui_1.Stack) `
  align-items: center;
  @media only screen and (max-width: 460px) {
    width: 100%;
  }
`;
exports.Title = (0, app_1.styled)(app_1.Text) `
  font-size: 1.375rem !important;
  font-weight: 500;
  letter-spacing: 0.15px;
  font-family: DM Sans;
  text-align: center;
  color: black;
`;
exports.InfoWrap = (0, app_1.styled)(ui_1.Grid) `
  grid-gap: ${(theme) => theme.spacing.small};
  font-size: 0.875rem;
  > div {
    align-items: center;
  }
  > div:first-child {
    justify-self: end;
  }
  > div:last-child {
    justify-self: start;
  }
  @media only screen and (max-width: 460px) {
    grid-template-columns: minmax(0, 1fr);
    grid-row-gap: unset;
    > div:first-child {
      justify-self: start;
    }
    > div:last-child {
      justify-self: start;
    }
    padding-left: ${(theme) => theme.spacing.extraSmall};
  }
`;
exports.OrderCard = (0, app_1.styled)(ui_1.Card) `
  background: white;
  padding: 2.25rem;
  max-width: 31rem;
  width: 100%;
  border-radius: 0;
  @media only screen and (max-width: 460px) {
    width: 100%;
    padding: ${(theme) => theme.spacing.small};
  }
`;
exports.MotionOrderCard = (0, framer_motion_1.motion)(exports.OrderCard);
exports.Divider = app_1.styled.div `
  height: 1px;
  background: ${(theme) => theme.stroke};
  width: 100%;
`;
exports.ProductWrap = (0, app_1.styled)(ui_1.Grid) `
  grid-row-gap: 0.5rem;
`;
exports.ProductTitle = app_1.styled.span `
  font-weight: 700;
  font-size: 0.9375rem;
`;
exports.ProductPrice = app_1.styled.span `
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 150%;

  > span {
    font-weight: 400;
    letter-spacing: 0.25px;
    margin-right: 0.2rem;
  }
`;
exports.ProductTax = app_1.styled.span `
  color: #6e7080;
  font-size: 0.875rem;
  text-align: end;
`;
exports.PriceRowTitle = app_1.styled.span `
  font-size: 0.875rem;
`;
exports.PriceRowValue = app_1.styled.span `
  font-size: 0.875rem;
  font-weight: 700;
  display: flex;
  justify-content: flex-end;
`;
exports.SmallSkeleton = (0, app_1.styled)(ui_1.Skeleton) `
  width: 100%;
  max-width: 5rem;
`;
exports.OrderPriceTitle = (0, app_1.styled)(app_1.Text) `
  font-size: 1.25rem !important;
  line-height: 150% !important;
  font-weight: 500 !important;
`;
exports.OrderPrice = (0, app_1.styled)(exports.ProductPrice) `
  font-size: 1.25rem;
  font-weight: 500;
  text-align: end;
`;
exports.OrderTax = (0, app_1.styled)(exports.ProductTax) `
  grid-column: span 2;
  display: flex;
  justify-content: flex-end;
`;
exports.OrderPriceWrap = (0, app_1.styled)(ui_1.Grid) `
  margin-top: ${(theme) => theme.spacing.medium} !important;
`;
exports.CenteredStack = (0, app_1.styled)(ui_1.Stack) `
  justify-content: center;
`;
exports.DataWrap = app_1.styled.div `
  > * {
    width: 100%;
    > div {
      text-align: center;
      width: 100%;
    }
  }
`;
exports.CouponAccordion = (0, app_1.styled)(ui_1.Accordion.Element) `
  border: none;
  > div {
    padding: 0;
    > svg {
      margin-left: 0;
    }
  }
`;
exports.CouponsWrap = app_1.styled.div `
  padding-top: ${(theme) => theme.spacing.small};
`;
